const Alert = ({color, message, alertOpen, show}) => {

    if (show) {
        setTimeout(() => {
            alertOpen(false)
        }, 5000)
    }
    return show && (
        <>
            <div
                className={`bg-${color}-500 z-10 w-40  min-w-fit text-white py-4 mt-14 fixed items-center rounded  left-2/4  -translate-x-2/4`}>
                <button
                    className="absolute bg-transparent text-2xl font-semibold leading-none right-0 top-0 outline-none focus:outline-none"
                    onClick={() => alertOpen(false)}
                >
                    <span>×</span>
                </button>
                <span className={`bg-${color}-500  text-center inline-block break-normal px-2`}>{message}</span>

            </div>

            <div className="bg-blue-500 hidden"/>
            <div className="bg-red-500 hidden"/>

        </>
    );
};
export default Alert;